import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DesarrollaList from '../components/DesarrollaList';
import EtiquetasPage from './EtiquetasPage';
import InfluencerList from '../components/InfluencerList';
import GestionUsuarios from './GestionUsuarios';
import { tienePestanaConfiguracion } from '../utils/pantallas';
import './DesarrollaPage.css';

const TABS = [
  { id: 'desarrolladores', label: 'Desarrolladores' },
  { id: 'etiquetas', label: 'Etiquetas' },
  { id: 'cuentas', label: 'Cuentas' },
  { id: 'usuarios', label: 'Usuarios' },
];

/**
 * Pantalla unificada: absorbe las antiguas pantallas /desarrolla, /etiquetas e /influencers
 * como tabs. La tab activa vive en la URL (?tab=etiquetas) para poder
 * enlazarla y para que el redirect desde /etiquetas funcione.
 */
const DesarrollaPage = ({ user }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tabsVisibles = TABS.filter(t => tienePestanaConfiguracion(user, t.id));
  const activa = tabsVisibles.some(t => t.id === tabParam) ? tabParam : (tabsVisibles[0]?.id || 'desarrolladores');

  const cambiarTab = (id) => {
    setSearchParams(id === 'desarrolladores' ? {} : { tab: id }, { replace: true });
  };

  return (
    <div className="dv-page">
      <div className="dv-tabs" role="tablist">
        {tabsVisibles.map(t => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={activa === t.id}
            className={`dv-tab${activa === t.id ? ' active' : ''}`}
            onClick={() => cambiarTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="dv-tab-content" role="tabpanel">
        {activa === 'desarrolladores' && <DesarrollaList />}
        {activa === 'etiquetas' && <EtiquetasPage />}
        {activa === 'cuentas' && <InfluencerList />}
        {activa === 'usuarios' && <GestionUsuarios />}
      </div>
    </div>
  );
};

export default DesarrollaPage;
